// Date 2021-10-16 09:34:49

import emEntityListView from "@/components/em/EmEntity/ListView";
import emEntityEditView from "@/components/em/EmEntity/EditView";
import emWorkflowListView from "@/components/em/EmWorkflow/ListView";
import emWorkflowTaskView from "@/components/em/EmWorkflow/TaskView";
import emLevelTreeListView from "@/components/em/EmLevelTree/ListView";

import mintalMesInventoryMaterialQuantityList from "@/views/mintalMes/inventory/MintalMesInventoryMaterialQuantityList.vue";
import mintalMesInventoryMaterialQuantityEdit from "@/views/mintalMes/inventory/MintalMesInventoryMaterialQuantityEdit.vue";
import mintalMesInventoryQuantityAdjustmentList from "@/views/mintalMes/inventory/MintalMesInventoryQuantityAdjustmentList.vue";
import mintalMesInventoryQuantityAdjustmentEdit from "@/views/mintalMes/inventory/MintalMesInventoryQuantityAdjustmentEdit.vue";
import mintalMesInventoryInputOutputEdit from "@/views/mintalMes/inventory/MintalMesInventoryInputOutputEdit.vue";
import mintalMesInventoryInputOutputList from "@/views/mintalMes/inventory/MintalMesInventoryInputOutputList.vue";
const metaObject = {requiresAuth: true, roles: ['mmf']};

export default [
//公用组件注册
//自定义页面注册
            {
            path: "/mintalMes/inventory/mintalMesInventoryMaterialQuantityList",
            name: "mintalMesInventoryMaterialQuantityList",
            component: mintalMesInventoryMaterialQuantityList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/inventory/mintalMesInventoryMaterialQuantityEdit",
            name: "mintalMesInventoryMaterialQuantityEdit",
            component: mintalMesInventoryMaterialQuantityEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/inventory/mintalMesInventoryQuantityAdjustmentList",
            name: "mintalMesInventoryQuantityAdjustmentList",
            component: mintalMesInventoryQuantityAdjustmentList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/inventory/mintalMesInventoryQuantityAdjustmentEdit",
            name: "mintalMesInventoryQuantityAdjustmentEdit",
            component: mintalMesInventoryQuantityAdjustmentEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/inventory/mintalMesInventoryInputOutputEdit",
            name: "mintalMesInventoryInputOutputEdit",
            component: mintalMesInventoryInputOutputEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/mintalMes/inventory/mintalMesInventoryInputOutputList",
            name: "mintalMesInventoryInputOutputList",
            component: mintalMesInventoryInputOutputList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            }
]